import { Trash2 as UiTrash2 } from './icons';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import api from '../api';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function BankAccounts() {
  const [accounts, setAccounts] = useState([]);
  const [form, setForm] = useState({ card_number: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [cardInput, setCardInput] = useState('');

  const token = localStorage.getItem('authToken');
  const config = { headers: { Authorization: `Bearer ${token}` } };

  // نقشه لوگوهای بانک
  const bankLogos = {
    'انصار': '/bank-logos/Ansar.svg',
    'آینده': '/bank-logos/Ayandeh.svg',
    'بانک مرکزی': '/bank-logos/Bank_Markazi.svg',
    'کاسپین': '/bank-logos/Caspian.svg',
    'دی': '/bank-logos/Dey.svg',
    'اقتصاد نوین': '/bank-logos/Eghtesad_Novin.svg',
    'فیوچربانک': '/bank-logos/Futurebank.svg',
    'گردشگری': '/bank-logos/Gardeshgari.svg',
    'قوامین': '/bank-logos/Ghavamin.svg',
    'حکمت': '/bank-logos/Hekmat.svg',
    'ایران اروپا': '/bank-logos/Iran_Europe.svg',
    'ایران ونزوئلا': '/bank-logos/Iran_Venezuela.svg',
    'ایران زمین': '/bank-logos/Iran_Zamin.svg',
    'کارآفرین': '/bank-logos/Karafarin.svg',
    'کشاورزی': '/bank-logos/Keshavarzi.svg',
    'خاورمیانه': '/bank-logos/Khavar_Mianeh.svg',
    'کوشار': '/bank-logos/Kosar.svg',
    'مسکن': '/bank-logos/Maskan.svg',
    'مهر اقتصاد': '/bank-logos/Mehr_Eghtesad.svg',
    'مهر ایران': '/bank-logos/Mehr_Iran.svg',
    'ملل': '/bank-logos/Melall.svg',
    'ملت': '/bank-logos/Mellat.svg',
    'ملی': '/bank-logos/Melli.svg',
    'نور': '/bank-logos/Noor.svg',
    'پارسیان': '/bank-logos/Parsian.svg',
    'پاسارگاد': '/bank-logos/Pasargad.svg',
    'پست بانک': '/bank-logos/Postbank.svg',
    'رفاه': '/bank-logos/Refah.svg',
    'رسالت': '/bank-logos/Resalat.svg',
    'صادرات': '/bank-logos/Saderat.svg',
    'سامان': '/bank-logos/Saman.svg',
    'صنعت و معدن': '/bank-logos/Sanat_Madan.svg',
    'سرمایه': '/bank-logos/Sarmayeh.svg',
    'سپه': '/bank-logos/Sepah.svg',
    'شهر': '/bank-logos/Shahr.svg',
    'سینا': '/bank-logos/Sina.svg',
    'استاندارد چارترد': '/bank-logos/Standard_Chartered.svg',
    'تعاون اسلامی': '/bank-logos/Taavon_Eslami.svg',
    'تجارت': '/bank-logos/Tejarat.svg',
    'توسعه': '/bank-logos/Tosee.svg',
    'توسعه صادرات': '/bank-logos/Tosee_Saderat.svg',
    'توسعه تعاون': '/bank-logos/Tosee_Taavon.svg',
    default: '/bank-logos/default.svg',
  };

  useEffect(() => {
    fetchAccounts();
  }, []);

  const fetchAccounts = async () => {
    try {
      const res = await api.get('/api/bank-accounts', config);
      setAccounts(res.data);
    } catch (err) {
      toast.error('خطا در دریافت حساب‌های بانکی');
    }
  };

  const handleCardInput = (e) => {
    let value = e.target.value.replace(/\D/g, '').slice(0, 16);
    setCardInput(value);
    setForm({ card_number: value });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (form.card_number.length !== 16) {
      setError('شماره کارت باید دقیقاً ۱۶ رقم باشد');
      setLoading(false);
      return;
    }

    try {
      await api.post('/api/bank-accounts', form, config);
      toast.success('حساب بانکی با موفقیت ثبت شد');
      setCardInput('');
      setForm({ card_number: '' });
      fetchAccounts();
    } catch (err) {
      setError(err.response?.data?.message || 'خطا در ثبت حساب');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('آیا از حذف این حساب مطمئن هستید؟')) return;

    try {
      await api.delete(`/api/bank-accounts/${id}`, config);
      toast.success('حساب با موفقیت حذف شد');
      fetchAccounts();
    } catch (err) {
      toast.error(err.response?.data?.message || 'خطا در حذف حساب');
    }
  };

  const formatCardNumber = (num) => num.replace(/(\d{4})(?=\d)/g, '$1 - ');
  const formatIban = (iban) => {
    const cleaned = iban.replace(/\s/g, '');
    return cleaned.replace(/(IR\d{2})(\d{4})(\d{4})(\d{4})(\d{4})(\d{4})(\d{2})/, '$1 - $2 - $3 - $4 - $5 - $6 - $7');
  };

  const getBankLogo = (name) => bankLogos[name?.trim()] || bankLogos.default;

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} rtl />

      <div className="bg-white rounded-3xl shadow-xl p-6 md:p-8 lg:p-10">
        {/* فرم افزودن کارت */}
        <div className="mb-10">
          <h3 className="text-xl font-bold text-gray-800 mb-4">افزودن حساب جدید</h3>
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">شماره کارت (۱۶ رقم)</label>
              <input
                type="text"
                inputMode="numeric"
                value={cardInput}
                onChange={handleCardInput}
                placeholder="6037 9912 3456 7890"
                className="w-full px-4 py-3 text-lg font-mono text-left direction-ltr border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition"
                dir="ltr"
              />
              <p className="text-xs text-gray-500 mt-1 text-left">فقط اعداد — حداکثر ۱۶ رقم</p>
            </div>

            {error && <p className="text-red-600 text-sm bg-red-50 px-4 py-2 rounded-lg">{error}</p>}

            <button
              type="submit"
              disabled={loading || cardInput.length !== 16}
              className={`w-full py-3 rounded-xl font-semibold text-white transition-all transform ${
                loading || cardInput.length !== 16
                  ? 'bg-gray-400 cursor-not-allowed'
                  : 'bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 hover:shadow-lg active:scale-98'
              }`}
            >
              {loading ? 'در حال ثبت...' : 'ثبت حساب بانکی'}
            </button>
          </form>
        </div>

        {/* لیست حساب‌ها */}
        <div>
          <h3 className="text-xl font-bold text-gray-800 mb-6">حساب‌های ثبت‌شده</h3>

          {accounts.length === 0 ? (
            <div className="text-center py-12">
              <div className="bg-gray-200 border-2 border-dashed rounded-xl w-20 h-20 mx-auto mb-4" />
              <p className="text-gray-500">هنوز هیچ حسابی ثبت نکرده‌اید</p>
              <p className="text-sm text-gray-400 mt-1">از بالا حساب جدید اضافه کنید</p>
            </div>
          ) : (
            <div className="grid gap-5 sm:grid-cols-1 md:grid-cols-2">
              {accounts.map((account) => (
                <div
                  key={account.id}
                  className="group relative bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl p-5 shadow-md hover:shadow-xl transition-all duration-300 border border-gray-200"
                >
                  {/* لوگو بانک */}
                  <div className="flex items-start justify-between mb-3">
                    <img
                      src={getBankLogo(account.bank_name)}
                      alt={account.bank_name}
                      className="w-14 h-14 object-contain rounded-lg shadow-sm bg-white p-2"
                      onError={(e) => (e.target.src = bankLogos.default)}
                    />
                    <button
                      onClick={() => handleDelete(account.id)}
                      className="text-red-500 hover:text-red-700 opacity-0 group-hover:opacity-100 transition-opacity p-2"
                      title="حذف حساب"
                    >
                      <UiTrash2 className="w-5 h-5" />
                    </button>
                  </div>

                  {/* اطلاعات */}
                  <div className="space-y-2">
                    <p className="font-semibold text-gray-800 text-lg">{account.bank_name}</p>
                    <p className="text-sm text-gray-600">{account.account_holder_name}</p>

                    <div className="bg-white/80 rounded-lg p-3 mt-3 font-mono text-sm space-y-1">
                      <p className="text-left text-gray-700">
                        کارت: <span dir="ltr">{formatCardNumber(account.card_number)}</span>
                      </p>
                      <p className="text-left text-gray-700 text-xs">
                        شبا: <span dir="ltr">{formatIban(account.iban)}</span>
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
}